import React, { FC } from 'react';
import { handleDaysAgo } from '../../../utils/daysAgo';
import cls from 'classnames';
import { setActiveSwap } from '../../../ducks/app/actions';
import { ISwap } from '../../../types/swap';
import { SKSwapCard } from '../../../components/SwapKiwi/SwapCard';
import { useWeb3React } from '@web3-react/core';

export interface ISwapList {
  swapList: ISwap[];
  onSwapClick: (id: string) => void;
  notExpandable?: boolean;
}

export const SwapList: FC<ISwapList> = ({ swapList, onSwapClick, notExpandable }) => {
  const swapStatusUI: {
    [key: string]: {
      text: string;
      notification?: string;
    };
  } = {
    INITIATED: {
      text: 'Answered',
      notification: 'Accept or reject a swap',
    },
    PROPOSED: {
      text: 'Proposed',
      notification: 'You have a new swap',
    },
    EXECUTED: {
      text: 'Accepted',
    },
    REJECTED: {
      text: 'Rejected',
    },
    CANCELLED: {
      text: 'Cancelled',
    },
  };

  const onShowMoreClick = (swap: ISwap): void => {
    setActiveSwap(swap);
    onSwapClick(swap.id);
  };

  const { account } = useWeb3React();

  return (
    <div className="swap-list">
      {swapList.map((swap, index) => {
        const isUserProposer = swap.fromUser.toLowerCase() === account?.toLowerCase() ? true : false;
        const parts = [
          {
            addedEther: parseFloat(swap.userEth),
            NFTs: swap.userNFTs,
            walletAddress: account?.toLowerCase() as string,
          },
          {
            addedEther: parseFloat(swap.offeredEth),
            NFTs: swap.offeredNFTs,
            walletAddress: account?.toLowerCase() !== swap.fromUser ? swap.fromUser : swap.toUser,
          },
        ];
        const numberOfSwaps = swapList.length ?? 0;
        return (
          <div
            key={index}
            className={cls(
              index === numberOfSwaps - 1 ? '' : 'border-b border-cloud-900',
              index % 2 === 0 ? 'bg-onion-50' : 'bg-onion-100',
            )}
          >
            <SKSwapCard
              notExpandable={notExpandable}
              parts={parts}
              key={`${swap.contract}--${index}`}
              swapStatus={swap.status}
              statusDates={{ statusSpan: swapStatusUI[swap.status].text, timestamp: handleDaysAgo(swap.timeStamp) }}
              isUserProposer={isUserProposer}
              onShowMoreClick={(): void => onShowMoreClick(swap)}
            />
          </div>
        );
      })}
    </div>
  );
};
